import React from 'react';
import { Link } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';

function DropdownMenu() {
  return (
    <DropdownButton className="dropdown-countries-button" variant="success" title="Countries">
      <Dropdown.Item as={Link} to="/CanadaSection">Canada</Dropdown.Item>
      <Dropdown.Item as={Link} to="/ChinaSection">China</Dropdown.Item>
      <Dropdown.Item as={Link} to="/PhillipinesSection">Philippines</Dropdown.Item>
      <Dropdown.Item as={Link} to="/VenezuelaSection">Venezuela</Dropdown.Item>
    </DropdownButton>
  );
}

export default DropdownMenu;